import HomePage from '@/pages/HomePage'
import AdminProjectsPage from '@/pages/admin/AdminProjectsPage'
import SuperAdminClientsPage from '@/pages/admin/SuperAdminClientsPage'
import ClientPortfolioPage from '@/pages/my/ClientPortfolioPage'
import ManagerLandingPage from '@/pages/my/ManagerLandingPage'
import MyBoardPage from '@/pages/my/MyBoardPage'
import type { RoleKey } from '@/access/roles'
import { useAppSelector } from '@/store'
import { selectActiveRoleKey } from '@/features/auth/slices/sessionSlice'

/**
 * `/` stays the shared entry point and RENDERS the current role's landing —
 * it does not redirect, so a switch of role re-lands without a reload and
 * without touching the URL (AC-1.3).
 *
 * The map is a total `Record<RoleKey, …>`, so adding a role without giving it
 * a landing is a COMPILE ERROR rather than a blank screen. The four roles this
 * ticket deliberately leaves unchanged render today's Home — that is the
 * decision, not an omission (AC-1.2).
 *
 * This component contains no markup of its own.
 */
const LANDINGS: Readonly<Record<RoleKey, () => React.JSX.Element>> = {
  'project-manager': () => <HomePage />,
  consultant: () => <MyBoardPage scope="multi" />,
  manager: () => <ManagerLandingPage />,
  hr: () => <HomePage />,
  expert: () => <HomePage />,
  analyst: () => <HomePage />,
  admin: () => <AdminProjectsPage />,
  'super-admin': () => <SuperAdminClientsPage />,
  'client-manager': () => <ClientPortfolioPage />,
  'client-employee': () => <MyBoardPage scope="single" />,
}

export default function RoleLanding() {
  const role = useAppSelector(selectActiveRoleKey)
  return LANDINGS[role]()
}
